import { getStyle } from "./getStyle.js";
export function getForm(options = {}) {
    const { id = `instrument-${crypto.randomUUID()}` } = options;
    return {
        id,
        html: `<style>${getStyle(id)}</style>
<div id="${id}">
  <div id="tabs" class="tabs"></div>
  <div id="form-container" class="form-container"></div>
</div>`,
    };
}
//# sourceMappingURL=getForm.js.map